// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".release-kit-page[data-v-5973d32a]{max-width:1200px;margin:0 auto}.communication-card[data-v-5973d32a]{height:100%}.communication-copy[data-v-5973d32a]{white-space:pre-wrap;word-break:break-word;font-family:inherit;font-size:13px;line-height:1.55;margin:0;padding:12px;border-radius:6px}.communication-copy-light[data-v-5973d32a]{color:#111827;background-color:rgba(0,0,0,.04)}.communication-copy-dark[data-v-5973d32a]{color:#f3f4f6;background-color:rgba(255,255,255,.08)}", ""]);
// Exports
module.exports = exports;
